import { render, staticRenderFns } from "./AppMetadataJson.vue?vue&type=template&id=cb413902"
import script from "./AppMetadataJson.vue?vue&type=script&lang=js"
export * from "./AppMetadataJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports